<template>
  <div id="overlay">
      <breeding-rhombus-spinner :animation-duration="500" :size="65" color="#ff1d5e" class="center"/>
      <div v-if="showProgress" class="center" style="top: 68%;left: 53%; width:50%;" >
        <span class="percentText">{{percentCompleted}}</span>
      </div>
    
  </div>
</template>

<script>
import { BreedingRhombusSpinner } from "epic-spinners";
import axios from "axios";
import store from "../store";
import {mapState} from "vuex";
export default {
  props: {
  
  },
  computed: {
    ...mapState("loader", ["progressEvent"]),
  },
  data() {
    return {
      percentCompleted:"0%",
      showProgress: false,
    }
  },
  watch: {
    async progressEvent(val, oldVal) {
      if(this.progressEvent.isTrusted){
      const total = this.progressEvent.numOfImages* 94371;
      const current = this.progressEvent.loaded;

      this.percentCompleted = Math.floor(current / total * 100)
      if(this.percentCompleted>100){
        this.percentCompleted=100;
      }
      this.percentCompleted=this.percentCompleted+"%";
      this.showProgress=true;
      this.progressEvent.showProgress=this.showProgress;
      this.progressEvent.percentCompleted=this.percentCompleted;
      console.log('completed: ',this.percentCompleted);
      if(this.percentCompleted=='100%'){
        setTimeout(() => {
          this.showProgress=false;
        this.percentCompleted="0%";
        },1000);
       
      }
    }
      
    }
  },

  components: {
    BreedingRhombusSpinner,
  },
};
</script>

<style>
#overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
  /* cursor: pointer; */
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
.percentText{
  color:#E40046; 
  font-size: larger;
  font-weight: 800;
}
</style>
